import { createApp } from "vue"
import NewsLetterFooter from "./NewsLetterFooter.vue"

const app = createApp(NewsLetterFooter)
app.mount("#newsletter-app-footer")
